import { useState } from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

export default function TextParaphrase() {
    const [results, setResult] = useState("");
    const [loading, setLoading] = useState(false);

    const controller = async () => {
        const text = document.getElementById("text").value;
        if (!text.trim()) {
            alert("Please enter some text to summarize.");
            return;
        }

        setLoading(true);
        try {
            const response = await fetch("https://ai-feats.nugenesisou.com/correct-grammar", {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ text })
            });

            if (!response.ok) {
                throw new Error("Failed to summarize the text.");
            }

            const data = await response.json();
            setResult(data.corrected_text || "No results generated.");
        } catch (error) {
            console.error("Error summarizing text:", error);
            setResult("Error summarizing text. Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Header />
            <main>
                <section class="pad breadcrumbs top-cover">
                    <div id="breadcrumb" class="content">
                        <a href="Home">Home</a><i></i>
                        <span>Text Grammar Checker</span>
                    </div>
                </section>

                <section class="security-hero">
                    <div class="content">
                        <div class="pad texts">
                            <h1><b>Free </b> AI Grammar Checker</h1>
                            <div class="subtitle">By NuGenesis</div>
                            <div class="text">Free online AI grammar checker tool is built to help professionals review text for grammar, spelling, and punctuation errors.</div>
                            {/* <div class="text">Enter or paste your text and press "Summarize."</div> */}
                        </div>
                    </div>
                </section>

                <section class="pad">
                    <div class="content">
                        <div class="text-par-container">
                            <p>To rewrite text, enter or paste it here and press "grammar checker"</p>
                            <div class="buttons">
                                <button>👋 Try Sample Text</button>
                                <button>📋 Paste Text</button>
                            </div>
                            <textarea class="not-focus" placeholder="Enter text here..." id="text"></textarea>
                            <div class="result">{results}</div>
                            <div class="upload">
                                <label for="fileUpload">📂 Upload Doc</label>
                                {/* <input type="file" id="fileUpload" style="display: none;"/> */}
                            </div>
                            <button class="submit-btn"  onClick={controller}>
                                {loading ? "Loading..." : "Checker"}
                            </button>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </>
    );
}
